import { setCacheReset } from "./axiosCacheReset";

export function fullReload() {
  navigator.serviceWorker.getRegistrations().then((registrations) => {
    registrations.forEach((registration) => {
      registration.unregister();
    });
  }); 
  caches.keys().then((keyList) => Promise.all(keyList.map((key) => caches.delete(key))));
  localStorage.clear();
  sessionStorage.clear();
  setCacheReset();
  const url = window.location.href;
  const ulrArr = url.split('#');
  const urlQry = ulrArr[0].split('?');
  const usp = new URLSearchParams(urlQry[1] || '');
  usp.set('_refresh', `${Date.now()}`);
  urlQry[1] = usp.toString();
  ulrArr[0] = urlQry.join('?');
  const resURL = ulrArr.join('#');
  fetch(resURL, {
    headers: {
      Pragma: 'no-cache',
      Expires: '-1',
      'Cache-Control': 'no-cache',
    },
  }).then(() => setTimeout(() => {
    window.location.href = resURL;
    window.location.reload(true);
  }, 100));
}